<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-address-card"></i> &nbsp;<ng-container i18n>Edit Invoice Logo</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-sm-6">
      <h6 i18n>Invoice Logo</h6>
      <div class="mb-3">
        <div class="invoice-logo-placeholder" *ngIf="!logoCtrl.value">
          <ng-container i18n>No Invoice Logo</ng-container>
        </div>
        <div *ngIf="logoCtrl.value" class="d-flex">
          <div class="mb-3 invoice-logo-wrapper">
            <img [src]="logoCtrl.value" class="invoice-logo" />
            <i
              class="cs-icon cs-icon-trash text-danger remove-icon-btn"
              i18n-matTooltip
              matTooltip="Remove Logo"
              (click)="onRemoveLogo()"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <h6 i18n>Image Description</h6>
      <br />
      <p>
        <ng-container i18n
          >The invoice logo appears at the top of the invoices you send to guests and statements you send to owners. By
          default it will be a AdvanceCM logo or blank, however you may select another image file by clicking UPLOAD
          button below.</ng-container
        >
        <strong i18n>We recommend a maximum image height of 70 pixels and a maximum image width of 500 pixels</strong>
      </p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="upload()" type="button" class="btn btn-secondary-info">
    <i class="fal fa-folder-open"></i> <ng-container i18n>upload</ng-container>
  </button>
  <button (click)="onSave()" type="button" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
